import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { useSplitContext } from '@zg-rentals/split';

import accessUtils from '../../../../../utils/accessUtils';

import { AppSelectors } from '../../../../../selectors';
import PremiumCompare from '../../../../PremiumCompare';
import PremiumFeatureSummary from '../../../../PremiumFeatureSummary';
import { ValueOfPremium } from '../ValueOfPremium';

const FreemiumPay = () => {
  const premiumCompareRef = useRef<HTMLDivElement>(null);
  const isScreenDesktop = useSelector((state) => AppSelectors.makeIsScreenXlGTE(state));

  const {
    split: { experiments: splitExperiments },
  } = useSplitContext();

  const canAccessValueOfPremium = accessUtils.canAccessValueOfPremium({ splitExperiments });

  return canAccessValueOfPremium ? (
    <ValueOfPremium />
  ) : (
    <div data-testid="FreemiumPay">
      <PremiumFeatureSummary premiumCompareRef={premiumCompareRef} hideCompareAndLearnMore={!isScreenDesktop} />
      <div ref={premiumCompareRef}>
        <PremiumCompare />
      </div>
    </div>
  );
};

export default FreemiumPay;
